import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('page-template-page-calc')) {
    return;
  }

  const dateInput = document.querySelector('#datumInput');
  if (dateInput) {
    flatpickr(dateInput, {
      dateFormat: 'd.m.Y',
      disableMobile: true,
      onChange: function(dates, str) {
        fetchShipEvents(str);
        updateValues();
      }
    });
  }

  const anlassSelect = document.querySelector('.anlass--select');
  if (anlassSelect) {
    anlassSelect.removeAttribute('disabled');
    // console.log('Enabled anlass--select');
  } else {
    // console.warn('anlass--select not found during initialization');
  }

  const timeInput = document.querySelector('#timeInput');
  if (timeInput) {
    flatpickr(timeInput, {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      time_24hr: true,
      minuteIncrement: 60,
      minTime: '00:00',
      maxTime: '23:00',
      onChange: function() {
        updateValues();
      }
    });
  }

  initializePersonsInput();
  setupEventListeners();
  const selectedRadio = document.querySelector('.schiff--radio:checked');
  if (selectedRadio) {
    const ship = selectedRadio.value.split(' ')[0];
    filterDockOptions(ship);
  }
  filterShipOptions();
  updateTabState();
  updateValues();

  const navItems = document.querySelectorAll('.calc-step--nav-item');
  navItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const stepId = item.getAttribute('data-step');
      if (item.classList.contains('blocked')) {
        e.preventDefault();
        return;
      }
      navItems.forEach(nav => nav.classList.remove('active', 'unlocked-inactive'));
      item.classList.add('active');
      document.querySelectorAll('.calc-step--section').forEach(section => section.classList.remove('active'));
      document.querySelector(`#calc-step-${stepId}`).classList.add('active');
      navItems.forEach(nav => {
        if (!nav.classList.contains('active') && !nav.classList.contains('blocked')) {
          nav.classList.add('unlocked-inactive');
        }
      });
    });
  });

  const nextButton = document.querySelector('.calc-step--next');
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      if (nextButton.classList.contains('blocked')) {
        e.preventDefault();
        return;
      }
      const stepId = nextButton.getAttribute('data-step');
      document.querySelectorAll('.calc-step--nav-item').forEach(nav => nav.classList.remove('active', 'unlocked-inactive'));
      const targetNav = document.querySelector(`.calc-step--nav-item[data-step="${stepId}"]`);
      targetNav.classList.add('active');
      document.querySelector('#calc-step-1').classList.remove('active');
      document.querySelector(`#calc-step-${stepId}`).classList.add('active');
      navItems.forEach(nav => {
        if (!nav.classList.contains('active') && !nav.classList.contains('blocked')) {
          nav.classList.add('unlocked-inactive');
        }
      });
      const calcStep2 = document.querySelector('#calc-step-2');
      if (calcStep2) {
        const offsetTop = calcStep2.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offsetTop - 290, behavior: 'smooth' });
      }
    });
  }
});

function initializePersonsInput() {
  const selectedRadio = document.querySelector('.schiff--radio:checked');
  if (selectedRadio) {
    const maxPersons = parseFloat(selectedRadio.value.split(' ')[5]);
    const personsInput = document.querySelector('#personsInput');
    personsInput.max = maxPersons;
    personsInput.value = maxPersons;
  }
}

function setupEventListeners() {
  const inputs = document.querySelectorAll('input, select');
  inputs.forEach(input => {
    input.addEventListener('input', () => {
      updateValues();
      updateTabState();
    });
    input.addEventListener('change', () => {
      updateValues();
      updateTabState();
    });
  });

  const shipRadios = document.querySelectorAll('.schiff--radio');
  shipRadios.forEach(radio => {
    radio.addEventListener('change', handleShipChange);
  });

  const shipListItems = document.querySelectorAll('.schiff--list--group--item');
  shipListItems.forEach(item => item.addEventListener('click', handleShipListClick));

  const anlassSelect = document.querySelector('.anlass--select');
  if (anlassSelect) {
    anlassSelect.addEventListener('change', () => {
      filterShipOptions();
      handleAnlassChange();
    });
  }
}

function handleAnlassChange() {
  const anlassSelect = document.querySelector('.anlass--select');
  const selectedOption = anlassSelect.selectedOptions[0];
  const redirectUrl = selectedOption.dataset.redirect;
  const offertenrechnerPage = anlassSelect.dataset.offertenrechnerPage;

  if (redirectUrl && document.body.classList.contains('page-template-page-calc') && redirectUrl === offertenrechnerPage) {
    return;
  }

  if (redirectUrl && redirectUrl !== window.location.pathname) {
    window.location.href = redirectUrl;
  }
}

function filterShipOptions() {
  const anlassSelect = document.querySelector('.anlass--select');
  const selectedOption = anlassSelect.selectedOptions[0];
  const showStafa = selectedOption.dataset.stafa === '1';
  const showSteinschiff = selectedOption.dataset.steinschiff === '1';

  document.querySelectorAll('.schiff--radio-label').forEach(label => {
    const bezeichnung = label.dataset.bezeichnung;
    let isVisible = true;

    if (bezeichnung === 'ls-staefa') {
      isVisible = showStafa;
    } else if (bezeichnung === 'ls-steinschiff') {
      isVisible = showSteinschiff;
    }

    label.style.display = isVisible ? '' : 'none';

    const selectedRadio = document.querySelector('.schiff--radio:checked');
    if (selectedRadio && selectedRadio.closest('.schiff--radio-label').style.display === 'none') {
      const firstVisibleRadio = document.querySelector('.schiff--radio-label:not([style="display: none;"]) .schiff--radio');
      if (firstVisibleRadio) {
        firstVisibleRadio.checked = true;
        handleShipChange();
      }
    }
  });
}

function validateInputs() {
  const anlassSelect = document.querySelector('.anlass--select').value;
  const fromSelect = document.querySelector('.standort--von--select').value;
  const toSelect = document.querySelector('.standort--bis--select').value;
  const dateInput = document.querySelector('#datumInput').value;
  const timeInput = document.querySelector('#timeInput').value;
  const durationInput = document.querySelector('#durationInput').value;
  const personsInput = document.querySelector('#personsInput').value;

  return (
    anlassSelect && anlassSelect !== '' &&
    fromSelect && fromSelect !== '' &&
    toSelect && toSelect !== '' &&
    dateInput && dateInput !== '' &&
    timeInput && timeInput !== '' &&
    durationInput && durationInput !== '' &&
    personsInput && personsInput !== ''
  );
}

function updateTabState() {
  const secondTab = document.querySelector('.calc-step--nav-item[data-step="2"]');
  const nextButton = document.querySelector('.calc-step--next');
  const isValid = validateInputs();

  if (isValid) {
    secondTab.classList.remove('blocked');
    nextButton.classList.remove('blocked');
    if (!secondTab.classList.contains('active')) {
      secondTab.classList.add('unlocked-inactive');
    }
  } else {
    secondTab.classList.add('blocked');
    secondTab.classList.remove('unlocked-inactive');
    nextButton.classList.add('blocked');
  }
}

function handleShipChange() {
  const selectedRadio = document.querySelector('.schiff--radio:checked');
  if (selectedRadio) {
    const maxPersons = parseFloat(selectedRadio.value.split(' ')[5]);
    const ship = selectedRadio.value.split(' ')[0];

    const personsInput = document.querySelector('#personsInput');
    personsInput.max = maxPersons;
    personsInput.value = maxPersons;

    const shipName = selectedRadio.closest('.schiff--radio-label').querySelector('.text-18').textContent.trim();
    document.querySelector('.schiff--display').textContent = shipName;
    filterDockOptions(ship);
    updateValues();
    updateTabState();

    const dateInput = document.querySelector('#datumInput');
    if (dateInput && dateInput.value) {
      fetchShipEvents(dateInput.value);
    }
  }
}

function filterDockOptions(ship) {
  const fromSelect = document.querySelector('.standort--von--select');
  const toSelect = document.querySelector('.standort--bis--select');

  document.querySelectorAll('.standort--option').forEach(option => {
    const isVisible = option.classList.contains(`val${ship}`);
    option.style.display = isVisible ? 'block' : 'none';
  });

  if (fromSelect.value && !fromSelect.querySelector(`option[value="${fromSelect.value}"]`).classList.contains(`val${ship}`)) {
    fromSelect.value = '';
  }
  if (toSelect.value && !toSelect.querySelector(`option[value="${toSelect.value}"]`).classList.contains(`val${ship}`)) {
    toSelect.value = '';
  }
}

function handleShipListClick(event) {
  const shipClass = event.currentTarget.classList[1];
  document.querySelectorAll('.list-group-item').forEach(item => item.classList.remove('active'));
  event.currentTarget.classList.add('active');

  document.querySelectorAll('.schiff--svg').forEach(svg => {
    svg.classList.toggle('block', svg.classList.contains(shipClass));
    svg.classList.toggle('hidden', !svg.classList.contains(shipClass));
  });
}

function updateValues() {
  updateDisplay();
  const priceData = calculatePrice();
  updatePriceDisplay(priceData);
  updateCustomMessages(priceData);
  copyToForm();
}

function updateDisplay() {
  const anlassSelect = document.querySelector('.anlass--select');
  const selectedRadio = document.querySelector('.schiff--radio:checked');
  if (selectedRadio) {
    const shipName = selectedRadio.closest('.schiff--radio-label').querySelector('.text-18').textContent.trim();
    document.querySelector('.schiff--display').textContent = shipName;
  }
  document.querySelector('.anlass--display').textContent = anlassSelect.selectedOptions[0]?.text || 'Bitte wählen';
  document.querySelector('.startort--display').textContent = document.querySelector('.standort--von--select').value || 'Bitte wählen';
  document.querySelector('.startort--display--name').textContent = document.querySelector('.standort--von--select').selectedOptions[0]?.dataset.label || 'Bitte wählen';
  document.querySelector('.zielort--display').textContent = document.querySelector('.standort--bis--select').value || 'Bitte wählen';
  document.querySelector('.zielort--display--name').textContent = document.querySelector('.standort--bis--select').selectedOptions[0]?.dataset.label || 'Bitte wählen';
  document.querySelector('.datum--display').textContent = document.querySelector('#datumInput').value;
  document.querySelector('.time--display').textContent = document.querySelector('#timeInput').value;
  document.querySelector('.anzahl--display').textContent = document.querySelector('#personsInput').value;
}

function calculatePrice() {
  const selectedRadio = document.querySelector('.schiff--radio:checked');
  if (!selectedRadio) {
    // console.log('No ship selected');
    return { total: 0, fromDuration: 0, toDuration: 0, wartezeit: 0, nightSurcharge: 0, holidaySurcharge: 0 };
  }

  const shipValues = selectedRadio.value.split(' ');
  const fromDuration = parseFloat(document.querySelector('.standort--von--select').value) || 0;
  const toDuration = parseFloat(document.querySelector('.standort--bis--select').value) || 0;
  const emptyTripCost = parseFloat(shipValues[1]);
  const baseFee = parseFloat(shipValues[2]);
  const includedHours = parseFloat(shipValues[3]);
  const extraHourCost = parseFloat(shipValues[4]);
  const duration = parseFloat(document.querySelector('#durationInput').value) || 0;
  const wartezeit = 0.5;
  const dateStr = document.querySelector('#datumInput').value;
  const timeStr = document.querySelector('#timeInput').value;

  // Debug shipValues
  // console.log('Ship values:', { shipValues, emptyTripCost, baseFee, includedHours, extraHourCost, wartezeit });

  // Get holidays and surcharges from data attributes
  const wrapper = document.querySelector('.calc-step--wrapper');
  let holidays = [];
  let nightSurchargePerHour = 70;
  let holidaySurchargePerHour = 100;
  if (wrapper) {
    try {
      holidays = JSON.parse(wrapper.dataset.holidays || '[]');
    } catch (e) {
      console.error('Error parsing holidays JSON:', e);
    }
    nightSurchargePerHour = parseFloat(wrapper.dataset.nachtzuschlag) || 70;
    holidaySurchargePerHour = parseFloat(wrapper.dataset.feiertagszuschlag) || 100;
  } else {
    console.warn('calc-step--wrapper not found');
  }

  // console.log('Holidays:', holidays);
  // console.log('Nachtzuschlag per hour:', nightSurchargePerHour);
  // console.log('Feiertagszuschlag per hour:', holidaySurchargePerHour);
  // console.log('Input values:', { dateStr, timeStr, duration, fromDuration, toDuration, wartezeit });

  if (dateStr && timeStr) {
    // Parse date in format dd.mm.yyyy
    const [day, month, year] = dateStr.split('.');
    const [hours, minutes] = timeStr.split(':').map(Number);
    const startDate = new Date(year, month - 1, day, hours, minutes);

    if (isNaN(startDate.getTime())) {
      console.error('Invalid startDate:', { year, month, day, timeStr });
      return { total: 0, fromDuration, toDuration, wartezeit, nightSurcharge: 0, holidaySurcharge: 0 };
    }

    // Mirror offerte.php: total_fahrzeit (with Wartezeit) for holiday + extra hours + display;
    // total_fahrzeit_nachtzuschlag (without Anfahrt and Wartezeit) for the night window.
    const totalDuration = fromDuration + duration + wartezeit + toDuration;
    const totalDurationNight = duration + toDuration;
    const endDate = new Date(startDate.getTime() + totalDurationNight * 60 * 60 * 1000);

    const pad2 = (n) => String(n).padStart(2, '0');
    const ymd = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    const hoursBetween = (a, b) => (b - a) / (1000 * 60 * 60);

    // Nachtzuschlag: mirrors offerte.php L286-303
    const nightStart = new Date(startDate);
    nightStart.setHours(23, 0, 0, 0);
    let nightHours = 0;
    if (endDate > nightStart && ymd(endDate) === ymd(nightStart)) {
      if (startDate >= nightStart) {
        nightHours = totalDurationNight;
      } else {
        nightHours = hoursBetween(nightStart, endDate);
      }
    } else if (endDate > nightStart) {
      nightHours = totalDurationNight - hoursBetween(startDate, nightStart);
    }
    nightHours = Math.max(0, nightHours);
    const nightSurcharge = nightHours * nightSurchargePerHour;

    // Feiertagszuschlag: mirrors offerte.php L311-355 (start-day full, else end-day hours after midnight)
    const isHolidayDate = (d) => holidays.some((h) => h.date === ymd(d));
    const isSundayStart = startDate.getDay() === 0;
    const isHolidayStart = isHolidayDate(startDate);
    const isSundayEnd = endDate.getDay() === 0;
    const isHolidayEnd = isHolidayDate(endDate);
    let holidayHours = 0;
    if (isSundayStart || isHolidayStart) {
      holidayHours = totalDuration;
    } else if (isSundayEnd || isHolidayEnd) {
      const midnight = new Date(startDate);
      midnight.setHours(0, 0, 0, 0);
      midnight.setDate(midnight.getDate() + 1);
      if (endDate > midnight) {
        holidayHours = hoursBetween(midnight, endDate);
      }
    }
    const holidaySurcharge = holidayHours * holidaySurchargePerHour;

    // Zwischentotal exkl. MWSt (offerte.php L423). The site shows prices excl. MwSt;
    // VAT is added only in the PDF (offerte.php L426-429).
    const extraHours = Math.max(0, totalDuration - includedHours);
    const total = baseFee + (extraHours * extraHourCost) + nightSurcharge + holidaySurcharge;

    const formField = document.querySelector('#input_2_14');
    if (formField) formField.value = dateStr;

    return { total, fromDuration, toDuration, wartezeit, nightSurcharge, holidaySurcharge };
  } else {
    // console.log('Missing date or time, returning zero values');
  }
  return { total: 0, fromDuration, toDuration, wartezeit: 0, nightSurcharge: 0, holidaySurcharge: 0 };
}

function formatSwissPrice(number) {
  const parts = number.toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return `${integerPart}.${parts[1]}`;
}

function updatePriceDisplay({ total }) {
  const totalPriceElements = document.querySelectorAll('.total--price');
  totalPriceElements.forEach(totalPrice => {
    totalPrice.textContent = formatSwissPrice(total);
  });

  document.querySelectorAll('.show--if--price').forEach(showPrice => {
    showPrice.classList.toggle('block', total > 0);
    showPrice.classList.toggle('hidden', total <= 0);
  });
  document.querySelectorAll('.hide--if--price').forEach(hidePrice => {
    hidePrice.classList.toggle('block', total <= 0);
    hidePrice.classList.toggle('hidden', total > 0);
  });
}

function updateCustomMessages({ fromDuration, toDuration, wartezeit }) {
  const totalDuration = fromDuration + toDuration + wartezeit;
  document.querySelectorAll('.custom--message').forEach(message => {
    const from = parseFloat(message.querySelector('.fromDuration').textContent);
    const till = parseFloat(message.querySelector('.tillDuration').textContent);

    if (totalDuration >= from && totalDuration <= till) {
      message.style.display = 'none';
      message.classList.remove('hidden');
      message.classList.add('flex');
      message.offsetHeight;
      message.style.display = 'flex';
    } else {
      message.style.display = 'flex';
      message.classList.remove('flex');
      message.classList.add('hidden');
      message.style.display = 'none';
    }
  });
}

function copyToForm() {
  const anlass = document.querySelector('.anlass--select').selectedOptions[0]?.text || '';
  const schiff = document.querySelector('.schiff--radio:checked')?.closest('.schiff--radio-label').querySelector('.text-18').textContent.trim() || '';
  const startort = document.querySelector('.standort--von--select').selectedOptions[0]?.dataset.label || '';
  const zielort = document.querySelector('.standort--bis--select').selectedOptions[0]?.dataset.label || '';
  const personen = document.querySelector('#personsInput').value;
  const datum = document.querySelector('#datumInput').value;
  const uhrzeit = document.querySelector('#timeInput').value;
  const dauer = document.querySelector('#durationInput').value;
  const priceData = calculatePrice();
  const gesamtpreisFormatted = formatSwissPrice(priceData.total);
  const gesamtpreisUnformatted = priceData.total.toFixed(2);

  document.querySelector('#input_2_27').value = anlass;
  document.querySelector('#input_2_16').value = schiff;
  document.querySelector('#input_2_17').value = startort;
  document.querySelector('#input_2_18').value = zielort;
  document.querySelector('#input_2_19').value = personen;
  document.querySelector('#input_2_23').value = datum;
  document.querySelector('#input_2_20').value = uhrzeit;
  document.querySelector('#input_2_21').value = dauer;
  document.querySelector('#input_2_22').value = gesamtpreisFormatted;
  document.querySelector('#input_2_26').value = gesamtpreisUnformatted;
}

function fetchShipEvents(selectedDate) {
  if (!selectedDate) {
    // console.log('No date selected');
    hideAvailability();
    return;
  }

  const shipValue = document.querySelector('#input_2_16').value;
  
  let shipId;
  if (shipValue === 'LS Stäfa') {
    shipId = 27;
  } else if (shipValue === 'LS Steinschiff') {
    shipId = 28;
  } else {
    // console.log('Unknown ship value:', shipValue);
    return;
  }

  if (typeof ship_events_ajax === 'undefined') {
    console.error('AJAX configuration not found');
    return;
  }

  const formData = new FormData();
  formData.append('action', 'get_ship_events');
  formData.append('ship', shipId);
  formData.append('date', selectedDate);
  formData.append('nonce', ship_events_ajax.nonce);

  fetch(ship_events_ajax.ajax_url, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      displayAvailability(data.data.events, selectedDate);
    } else {
      // console.log('No events found or error occurred');
      hideAvailability();
    }
  })
  .catch(error => {
    console.error('Error fetching ship events:', error);
  });
}

function displayAvailability(events, selectedDate) {
  let availabilityDiv = document.querySelector('#availability-info');
  
  if (!availabilityDiv) {
    availabilityDiv = document.createElement('div');
    availabilityDiv.id = 'availability-info';
    availabilityDiv.className = 'mt-4';
    
    const dateInput = document.querySelector('#datumInput');
    if (dateInput && dateInput.parentNode) {
      dateInput.parentNode.insertBefore(availabilityDiv, dateInput.nextSibling);
    }
  }
  
  if (events.length > 0) {
    const htmlLang = document.documentElement.getAttribute('lang');
    const isEnglish = htmlLang === 'en-US';
    
    const translations = {
      de: {
        availability: `Verfügbarkeit am ${selectedDate}`,
        reservation: 'Bestehende Reservation:',
        allDay: 'ganztägig',
        fromTime: 'ab',
        noTime: 'Zeit nicht angegeben'
      },
      en: {
        availability: `Availability on ${selectedDate}`,
        reservation: 'Existing Reservation:',
        allDay: 'all day',
        fromTime: 'from',
        noTime: 'Time not specified'
      }
    };
    
    const t = isEnglish ? translations.en : translations.de;
    
    let content = `<p class="text-12 font-semibold">${t.availability}</p>`;
    
    events.forEach(event => {
      let timeRange = '';
      if (event.start_time && event.end_time) {
        timeRange = `${event.start_time} - ${event.end_time}`;
      } else if (event.start_time) {
        timeRange = `${t.fromTime} ${event.start_time}`;
      } else if (event.allday === '1') {
        timeRange = t.allDay;
      } else {
        timeRange = t.noTime;
      }
      
      content += `<p class="text-12">${t.reservation} ${timeRange}</p>`;
    });
    
    availabilityDiv.innerHTML = content;
    availabilityDiv.style.display = 'block';
  } else {
    hideAvailability();
  }
}

function hideAvailability() {
  const availabilityDiv = document.querySelector('#availability-info');
  if (availabilityDiv) {
    availabilityDiv.style.display = 'none';
  }
}